import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime types.
 */

export const ROauthClient = t.readonly(
  t.type({
    name: t.string,
    clientId: t.string,
    redirectUrls: t.array(t.string),
    createdAt: t.Integer,
  }),
);

const ROauthClientSecret = t.readonly(
  t.type({
    clientSecret: t.string,
  }),
);

/*
 * Types.
 */

export interface OauthClientModel extends t.TypeOf<typeof ROauthClient> {}
export interface OauthClientSecretModel extends t.TypeOf<typeof ROauthClientSecret> {}

export interface UnsavedOauthClientModel extends Omit<OauthClientModel, 'name' | 'clientId' | 'createdAt'> {}

/*
 * IO methods.
 */

export function parseOauthClient(src: any): OauthClientModel {
  return {
    name: src.name,
    clientId: src.client_id,
    redirectUrls: src.redirect_urls,
    createdAt: src.created_at,
  };
}

export function serializeOauthClient(src: UnsavedOauthClientModel): any {
  return {
    redirect_urls: src.redirectUrls,
  };
}

export function parseOauthClientSecret(src: any): OauthClientSecretModel {
  return {
    clientSecret: src.client_secret,
  };
}

/*
 * API types.
 */

export const ApiOauthClient = makeApiType('oauthClient', ROauthClient, parseOauthClient);
export const ApiOauthClientSecret = makeApiType(
  'oauthClientSecret',
  ROauthClientSecret,
  parseOauthClientSecret,
);
